import { render } from "./ImportShapesModal.vue?vue&type=template&id=2b8f8a75&scoped=true"
import script from "./ImportShapesModal.vue?vue&type=script&lang=js"
export * from "./ImportShapesModal.vue?vue&type=script&lang=js"

import "./ImportShapesModal.vue?vue&type=style&index=0&id=2b8f8a75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8f8a75"]])

export default __exports__